import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons';
import { TextArea } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function TextAreaRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  return (
    <TextArea
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange((e.value as string) ?? '')}
      disabled={readOnly}
      maxLength={field.validation?.maxLength}
      placeholder={field.label}
      rows={4}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'TXA',
  label: 'Text Area / Notes',
  category: 'input',
  icon: <FontAwesomeIcon icon={faAlignLeft} fixedWidth />,
  defaultProps: { label: 'New notes field', isRequired: false },
  Renderer: TextAreaRenderer,
};
